import { DeliveryEta } from '@/types';
import { StoreState } from '@/redux/types';
import { getDeliveryEtaId } from '../utils/getDeliveryEtaId';
import { getCore } from './getCore';

export const getDeliveryEta =
  (productTypeId: string, printTypeIds: string[]) =>
  (state: StoreState): DeliveryEta | null | undefined =>
    getCore(state).deliveryEta[getDeliveryEtaId(productTypeId, printTypeIds)];
